<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">费用类型</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddCostType && !hideInUserEdit">
      <section class="searchBoxTwo">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddCostType = !hideInAddCostType"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <div>
            <label>渠道：</label>
            <a-radio-group v-model="finance_source_id">
              <a-radio :value="1">电脑端</a-radio>
              <a-radio :value="2">手机端</a-radio>
            </a-radio-group>
          </div>
          <div>
            <label>费用大类：</label>
            <a-select v-model="pid" style="width:200px">
              <a-select-option
                v-for="item in parentsList"
                :key="item.id"
                :value="item.id"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </div>
          <div>
            <label>字符串：</label>
            <a>
              <a-input v-model="query_field" placeholder="请输入类型名称" />
            </a>
          </div>
          <div>
            <a-button @click="onReset" style="margin-right:10px;"
              >重置</a-button
            >
            <a-button type="primary" icon="search" @click="onSearch"
              >搜索</a-button
            >
          </div>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                <span v-show="item.finance_source_ids.includes('1')"
                  >电脑端</span
                >
                <span v-show="item.finance_source_ids.split(',').length > 1"
                  >&nbsp;|&nbsp;</span
                >
                <span v-show="item.finance_source_ids.includes('2')"
                  >手机端</span
                >
                <!-- {{(item.finance_source_ids==''?'':item.finance_source_ids).split(",").map(Number)}} -->
              </td>
              <td>{{ item.pname }}</td>
              <td>{{ (item.name = "" ? "--" : item.name) }}</td>
              <td class="operation">
                <a style="color:#67C23A" @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addCostType v-on:hideInAdd="hideInAdd" v-if="hideInAddCostType" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <costTypeEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addCostType from "@/components/money/addCostType"; //增加用户
import costTypeEdit from "@/components/money/costTypeEdit"; //编辑用户
import { mapState } from "vuex";

export default {
  components: {
    addCostType,
    costTypeEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddCostType: false,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: ["渠道", "费用大类", "类型名称", "操作"],
      query_field: "",
      parentsList: [],
      pid: "",
      finance_source_id: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getParents(); //获取费用大类
  },
  methods: {
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
        }
      });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddCostType = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddCostType = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/lists";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          pid: this.pid,
          finance_source_id: this.finance_source_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    onReset() {
      this.query_field = "";
      this.pid = "";
      this.finance_source_id = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
